const domain = 'quickchat.ai';
export const isQuickchatEmail = (email: string): boolean => {
  const emailDomain = email.split('@')[1];
  return emailDomain === domain;
};
